import createReactClass from 'create-react-class';
// Import Libraries
import React      from 'react';
import classNames from 'classnames';
import Spinner    from './spinner';
// -----------------------------------------------------------
//  SpinnerCover
// -----------------------------------------------------------
var SpinnerCover = createReactClass({
  displayName: 'SpinnerCover',
  render: function(){
    return  <div className="spinner-cover">
              <div className={ classNames(["spinner-layer", { 'spinner-visible': this.props.spinning }]) }>
                <Spinner mini={ this.props.mini } />
              </div>
              <div className="content-layer">
                { this.props.children }
              </div>
            </div>;
  }
});

export default SpinnerCover;
